<template>
       <router-view />
</template>

<script>
export default {
  
  data(){
    return{
      
    }
  },
  components: {},
  beforeCreate(){

  },
  created(){
    
  },
  mounted(){
    
  },
  methods:{
    
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue